<section class="section py-6">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Planning</h2>
        @if (selectedTab !== 'upload') {
          <div class="vs-switcher">
            <button class="button vs-btn" [class.vs-active]="selectedVS === ValueStream.VS1" (click)="selectedVS = ValueStream.VS1">VS1</button>
            <button class="button vs-btn" [class.vs-active]="selectedVS === ValueStream.VS2" (click)="selectedVS = ValueStream.VS2">VS2</button>
          </div>
        }
      </div>
    </div>
  </section>

  <section class="section py-1">
    <div class="columns has-background-white">
      <div class="column">
        <div class="columns">
          <div class="column p-5">
            <div class="steps pb-5">
              @if (steps) {
                <app-upload-apo-steps [steps]="steps" (onSelectTab)="onSelectTab($event)"></app-upload-apo-steps>
              }
            </div>
            @if(selectedTab === 'upload') {
              <div class="upload-file">
                @if(isLoading) {
                  <section class="section py-6">
                    <app-spinner></app-spinner>
                  </section>
                } @else {
                  <app-file-upload (onUploadFile)="onUploadFile($event)" ></app-file-upload>
                }
              </div>
            }
            @if (selectedTab === 'view') {
              <div class="table-apo-upload">
                @if(isLoading) {
                  <section class="section py-6">
                    <app-spinner></app-spinner>
                  </section>
                }
                @if (!isLoading) {
                  <app-planning-orders-table
                    [columnsHeader]="COLUMNS_HEADER"
                    [dataTable]="currentVSOrders"
                    [blenderOptions]="blenderOptions"
                    [packagingMachineOptions]="packagingMachineOptions"
                    [demandTypeOptions]="demandTypeOptions"
                    (dataChange)="onOrdersChange($event)"
                  ></app-planning-orders-table>
                }
              </div>
            }
            @if (selectedTab === 'delays') {
              <app-apo-parameters [selectedVS]="selectedVS" (formValidityChange)="onDelaysFormValidityChange($event)"></app-apo-parameters>
            }
            @if(selectedTab === 'validate') {
              <app-apo-fine-tunning [tasks]="apoLogistics?.[selectedVS]" [calendar]="calendar" [cameraHeatmap]="cameraHeatmap" [selectedVS]="selectedVS" (tasksChange)="onApoLogisticsChange($event)"></app-apo-fine-tunning>
            }

            @if (selectedTab === 'validate' && apoFile) {
              <div class="table-apo">
                @if(isLoading) {
                  <section class="section py-6">
                    <app-spinner></app-spinner>
                  </section>
                }
                <div class="columns">
                  <div class="column">
                    <div class="legend">
                      <div class="item-legend">
                        <fa-icon class="item-legend-icon has-text-success" [icon]="faActiveCheck"></fa-icon>
                        <span class="item-legend-desc">Cargado en Kanbanize</span>
                      </div>
                      <div class="item-legend">
                        <fa-icon class="item-legend-icon inactive-icon" [icon]="faActiveCheck"></fa-icon>
                        <span class="item-legend-desc">Pendiende de cargar en Kanbanize</span>
                      </div>
                      <div class="item-legend">
                        <fa-icon class="item-legend-icon has-text-danger" [icon]="faCloseCheck"></fa-icon>
                        <span class="item-legend-desc">No se puede cargar en Kanbanize</span>
                      </div>
                    </div>
                  </div>
                </div>
                @if(!isLoading) {
                  <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="apoFile" ></app-generic-table>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
  @if (!isLoading) {
    <section class="section">
      <div class="columns">
        <div class="column is-3 is-offset-6">
          @if (selectedTab === 'validate') {
            <button class="button is-secondary is-fullwidth" [disabled]="!recalculatedApoLogistics" (click)="isModalVisible = true">Recalcular</button>
          }
        </div>
        <div class="column is-3">
          @if (selectedTab === 'view' ) {
            <button class="button is-primary is-fullwidth"  (click)="nextStep()">Siguiente</button> <!--[disabled]="apoUpload.length === 0"-->
          }
          @if (selectedTab === 'delays') {
            <button class="button is-primary is-fullwidth" [disabled]="!delaysFormValid" (click)="nextStep()">Siguiente</button>
          }
          @if (selectedTab === 'validate') {
            <button class="button is-primary is-fullwidth" (click)="confirm()">Finalizar</button>
          }
        </div>
      </div>
    </section>
  }
  <div class="modal" [ngClass]="{'is-active': isModalVisible }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head modal-card-head-delete">
        <p class="modal-card-title">Recalcular plamificación</p>
        <button type="button" class="delete" aria-label="close" (click)="isModalVisible = false"></button>
      </header>
      <section class="modal-card-body modal-card-body-delete">
        <div class="columns">
          <div class="column">
            <p class="message-confirm-delete">¿Estás seguro/a que deseas continuar?</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-space-between">
        <button type="button" class="button" (click)="isModalVisible = false">Cancelar</button>
        <button type="submit" class="button is-primary" (click)="recalculateApoLogistics()">Recalcular</button>
      </footer>
    </div>
  </div>
